import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";

import { unpackError } from "@dashboard/devices/api/helpers";

export const announcementEmailListTypes = {
    newsletterSubscribers: "NewsletterSubscribers",
} as const;

type AnnouncementEmailListType = (typeof announcementEmailListTypes)[keyof typeof announcementEmailListTypes];

export type ExportAnnouncementEmailsPayload = {
    listType?: AnnouncementEmailListType;
};

export type ExportAnnouncementEmailsResult = {
    blob: Blob;
    fileName: string;
};

function getExportFileName(listType?: AnnouncementEmailListType): string {
    return listType === announcementEmailListTypes.newsletterSubscribers ? "subscribers.csv" : "customers.csv";
}

export async function exportAnnouncementEmails(
    payload?: ExportAnnouncementEmailsPayload,
): Promise<ExportAnnouncementEmailsResult> {
    try {
        const endpoint = await RouteService.getAnnouncementsRoute();
        const response = await HttpService.get<Blob, AxiosResponse<Blob>>(endpoint + "emails.csv", {
            responseType: "blob",
            params: payload?.listType ? { listType: payload.listType } : undefined,
        });

        return { blob: response.data, fileName: getExportFileName(payload?.listType) };
    } catch (error) {
        throw unpackError(error);
    }
}
